import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BcServicesModule } from '@bancolombia/design-system-web/bc-services';
import { BcSharedModule } from './shared/bc-shared/bc-shared.module';
import { CommonsModule } from './shared/commons/commons.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Interceptor } from './modules/login/interceptor/interceptor';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    MsalModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    BcServicesModule.forRoot(),
    BcSharedModule,
    CommonsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
